import axios from "axios";
import { apiUrl } from '../utils/constants';
axios.defaults.withCredentials = true

const API_URL = `${apiUrl}/auth`;


const login = (data) => {
  return axios
    .post(API_URL + "/signin", data)
    .then((response) => {
      if (response.data.accessToken) {
        let { accessToken } = response.data;
        let token = `Bearer ${accessToken}`;
        localStorage.setItem("accessToken", token);
        axios.defaults.headers.common['Authorization'] = token;
      }
      return response.data;
    });
};

const getUserDetails = (data) => {
  return axios
    .get(API_URL, data)
    .then((response) => {
      console.log(response.data)
      return response.data;
    });
};


const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
  return axios
  .get(API_URL + "/logout")
  .then((response) => {
    return response.data;
  });
};

const forgotPin = (data) => {
  console.log(data)
  return axios.post(API_URL + "/forgot", data)
  .then((response) => {
    return response.data;
  });
};


export default {
  login,
  getUserDetails,
  logout,
  forgotPin
};